import RichText from "@/components/RichText";
import { SmartLink } from "../components/Primitives";
import { BTN_OUTLINE, CONTAINER, EYEBROW_LIGHT } from "../tokens";

// Mentions légales : colonne unique (max 820px), sur-titre, H1, filet, une
// section par bloc (H2 Cormorant 23px + corps 14px/1.85), bouton de retour.
export default function LegalContentSection({ props = {}, blocks = [] }) {
  const items = (blocks || []).filter((b) => b.type === "legal_block" && b.enabled !== false);

  return (
    <section>
      <div className={`${CONTAINER} px-5 md:px-11`} style={{ paddingTop: "clamp(48px,6vw,80px)", paddingBottom: "clamp(48px,6vw,80px)" }}>
      <div className="max-w-[820px]">
        <RichText as="div" className={EYEBROW_LIGHT} html={props.eyebrow} />
        <RichText
          as="h1"
          className="block font-display font-light text-[clamp(30px,4vw,46px)] leading-[1.12] text-ink mt-[18px]"
          html={props.heading}
        />
        <span className="block w-16 h-px bg-ink/25 mt-[30px] mb-10" aria-hidden="true" />

        <div className="grid gap-[34px]">
          {items.map((b) => (
            <div key={b.id} data-block-key={b.id}>
              <RichText
                as="h2"
                className="block font-display font-normal text-[23px] leading-[1.25] text-ink mb-3"
                html={b.props?.title}
              />
              <RichText
                as="div"
                preserveParagraphs
                className="text-[14px] leading-[1.85] font-light text-graphite [text-wrap:pretty] [&_p]:mb-3.5 [&_p:last-child]:mb-0 [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:text-ash"
                html={b.props?.body}
              />
            </div>
          ))}
        </div>

        {props.back_label && (
          <SmartLink url={props.back_url || "/"} className={`${BTN_OUTLINE} mt-11`}>
            {props.back_label}
          </SmartLink>
        )}
      </div>
      </div>
    </section>
  );
}
